import React from 'react';
import HomeLayout from '../../../components/Layout/HomeLayout';
import Content from '../../components/Pages/auth/SignIn';

function SignInInfoTrac() {
  document.title = 'InfoTrac: Sign In';

  return (
    <HomeLayout containerClassName="h-screen">
      <Content />
    </HomeLayout>
  );
}

export default SignInInfoTrac;
